import { useState } from 'react'
import { saveUser } from 'registry/actions'
import EmailPreferencesForm from 'registry/forms/email-preferences-form'
import TellUsWhyModal from 'registry/components/modals/tell-us-why-modal'
import { babylossPath } from 'lib/urls'

const EmailPreferences = () => {
  const [showModal, setShowModal] = useState(false)

  const handleSubmit = (data, dispatch) => {
    const unsubscribedAll = Object.values(data.user.emailPreferences).every(
      (field) => field === false
    )
    return dispatch(saveUser(data)).then(
      () => unsubscribedAll && setShowModal(true)
    )
  }

  const handleTellUsWhyModalOnSubmit = (reason) => {
    if (reason) {
      reason === 'Experienced a Loss'
        ? (window.location.href = babylossPath)
        : setShowModal(false)
    }
  }

  return (
    <>
      {showModal ? (
        <TellUsWhyModal
          subHeadingText="Why did you unsubscribe?"
          onSubmit={handleTellUsWhyModalOnSubmit}
        />
      ) : null}
      <EmailPreferencesForm _handleSubmit={handleSubmit} />
    </>
  )
}

export default EmailPreferences
